import React from "react";
import { useCapacityCalendarContext } from "./context";

/**
 * The day cells behind a row's content — the same strip for every level, so a first-level row and
 * the rows it expands into stand on one grid.
 *
 * A row that also carries a bar draws it over these rather than tinting them, because a bar spans
 * days continuously and a cell stops at every column border.
 *
 * The classes come resolved off the cell: this strip is drawn once per row, and a class merge per
 * cell per row was the largest share of what a board of rows cost to render.
 */
export function CapacityCalendarCells() {
	/** Context */
	const { controller } = useCapacityCalendarContext();

	/** Render */
	return (
		<React.Fragment>
			{controller.cells.map((cell) => (
				<div
					key={cell.date}
					className={cell.className}
				/>
			))}
		</React.Fragment>
	);
}
